import type { RouteRecordRaw } from 'vue-router'
import { PermissionAction, PermissionResource } from '@nailsupply/review-swagger/auth'
import { allGlobalconfigRoutes } from '@/pages/globalconfig/routes'

export const globalconfigRoutes: RouteRecordRaw = {
  path: '',
  component: () => import('@/layouts/main.vue'),
  meta: {
    requireAuth: true,
    requireStoreId: true,
    permission: { resource: PermissionResource.enum.global_config, action: PermissionAction.enum.view },
  },
  children: [
    ...allGlobalconfigRoutes,
  ],
}
